import { render, staticRenderFns } from "./galleriesTexts.vue?vue&type=template&id=3a0d65ca"
import script from "./galleriesTexts.vue?vue&type=script&lang=js"
export * from "./galleriesTexts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports